export default function BlankPdfIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
    >
      <path
        d="M11.2503 0.860352H2.24996C2.05106 0.860357 1.8603 0.939377 1.71965 1.08003C1.57901 1.22068 1.5 1.41144 1.5 1.61035V18.1104C1.5 18.3093 1.57901 18.5 1.71965 18.6407C1.8603 18.7813 2.05106 18.8603 2.24996 18.8604H15.75C15.9489 18.8603 16.1397 18.7813 16.2803 18.6407C16.421 18.5 16.5 18.3093 16.5 18.1104V6.11035M11.2503 0.860352L16.5 6.11035M11.2503 0.860352L11.25 6.11035H16.5"
        stroke="#DC3545"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
